import React, { useEffect, useState } from 'react';
import { Button, Tag } from '@stonelog/stonelog-design-system';
import { useSelector, useDispatch } from "react-redux";
import { hubsSelector } from '../../../../../../../../../features/senninha/hubsSlice';
import { manageSelectedRelocatePins, resetSelectedPreDeliveryPins, resetSelectedRelocatePins, resetUnassociatedPinAnyData, routesManagementSelector } from '../../../../../../../../../features/senninha/routesManagementSlice';
import AreaSelectControl from './AreaSelectControl';

import * as S from './styles';


const PreDeliveryRoutes = ({
    setNewWorkFlow,
    setRoutes
}) => {
    const dispatch = useDispatch()

    const {
        selectedHubInfos
    } = useSelector(hubsSelector);

    const {
        selectedPreDeliveryPins
    } = useSelector(routesManagementSelector);
    
    const getTotalOss = () => selectedPreDeliveryPins.reduce((sum, item) => sum += item.oss.length, 0)

    const managePinRemoval = (pin) => {
        dispatch(manageSelectedRelocatePins(pin))
    }

    const handleSaveClick = () => {
        setRoutes((p) => [...p, {
            type: 'preDelivery',
            angel: '',
            pins: selectedPreDeliveryPins,
            ossAmount: getTotalOss(),
            polo: selectedHubInfos.children,
        }])
        setNewWorkFlow(false)
        dispatch(resetSelectedRelocatePins());
        dispatch(resetSelectedPreDeliveryPins());
    }

    return (
        <S.RealocateContainer>
            <AreaSelectControl />
            <S.RealocateInfos>
                <p>
                    Total de pins selecionados
                </p>
                <span>
                    {selectedPreDeliveryPins.length}
                </span>
            </S.RealocateInfos>
            <S.RealocateInfos>
                <p>
                    Total de OS
                </p>
                <span>
                    {getTotalOss()}
                </span>
            </S.RealocateInfos>
            <S.RealocateTags>
            {selectedPreDeliveryPins.map(
                (item) => item.oss.map(({ id_os }, i) => 
                    (item.tipo !== 'any' && i === 0 || item.tipo === 'any') &&
                        <S.TagArea
                            key={i}
                            isBlocked={false}
                        >
                            <Tag
                                text={item.tipo === 'any' ? id_os.toString() : item.id_atendimento.toString()}
                                onClose={() => managePinRemoval(item)}
                            />
                        </S.TagArea>
                )
            )}
            </S.RealocateTags>

            <S.Footer>
                <Button
                    size='small'
                    onClick={() => {
                        setNewWorkFlow(false)
                        dispatch(resetSelectedRelocatePins())
                        dispatch(resetSelectedPreDeliveryPins());
                        dispatch(resetUnassociatedPinAnyData());
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    size='small'
                    type='primary'
                    disabled={!selectedPreDeliveryPins.length}
                    onClick={handleSaveClick}
                >
                    Salvar
                </Button>
            </S.Footer>
        </S.RealocateContainer>
    )
};

export default PreDeliveryRoutes;
